module.exports = __webpack_public_path__ + "static/media/turbines.ecaa8d2f.jpg";